// extracted by mini-css-extract-plugin
export var growableInput = "_7f-0";
export var tagContainer = "_7f-2";
export var textInput = "_7f-1";